// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file scale_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ScaleRecordStatus, ScaleRecordStatusJson, WasteType, WasteTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { IdRequestSchema, ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { RawScaleRecord, RawScaleRecordJson, ScaleRecord, ScaleRecordJson } from "./route_pb";
import { file_route } from "./route_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file scale_service.proto.
 */
export const file_scale_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_enums, file_general, file_google_protobuf_timestamp, file_route]);

/**
 * @generated from message raccoonai.ScaleBruttoRequest
 */
export type ScaleBruttoRequest = Message<"raccoonai.ScaleBruttoRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: required double weight_kg = 4 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * @generated from field: required raccoonai.WasteType waste_type = 5 [json_name = "waste_type"];
   */
  wasteType: WasteType;

  /**
   * @generated from field: optional double volume = 6;
   */
  volume: number;

  /**
   * @generated from field: optional bool use_truck_tare_weight = 7 [json_name = "use_truck_tare_weight"];
   */
  useTruckTareWeight: boolean;
};

/**
 * @generated from message raccoonai.ScaleBruttoRequest
 */
export type ScaleBruttoRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: required double weight_kg = 4 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required raccoonai.WasteType waste_type = 5 [json_name = "waste_type"];
   */
  waste_type?: WasteTypeJson;

  /**
   * @generated from field: optional double volume = 6;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional bool use_truck_tare_weight = 7 [json_name = "use_truck_tare_weight"];
   */
  use_truck_tare_weight?: boolean;
};

/**
 * Describes the message raccoonai.ScaleBruttoRequest.
 * Use `create(ScaleBruttoRequestSchema)` to create a new message.
 */
export const ScaleBruttoRequestSchema: GenMessage<ScaleBruttoRequest, {jsonType: ScaleBruttoRequestJson}> = /*@__PURE__*/
  messageDesc(file_scale_service, 0);

/**
 * @generated from message raccoonai.ScaleNettoRequest
 */
export type ScaleNettoRequest = Message<"raccoonai.ScaleNettoRequest"> & {
  /**
   * @generated from field: required uint64 scale_record_id = 1 [json_name = "scale_record_id"];
   */
  scaleRecordId: bigint;

  /**
   * @generated from field: required double weight_kg = 2 [json_name = "weight_kg"];
   */
  weightKg: number;
};

/**
 * @generated from message raccoonai.ScaleNettoRequest
 */
export type ScaleNettoRequestJson = {
  /**
   * @generated from field: required uint64 scale_record_id = 1 [json_name = "scale_record_id"];
   */
  scale_record_id?: string;

  /**
   * @generated from field: required double weight_kg = 2 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.ScaleNettoRequest.
 * Use `create(ScaleNettoRequestSchema)` to create a new message.
 */
export const ScaleNettoRequestSchema: GenMessage<ScaleNettoRequest, {jsonType: ScaleNettoRequestJson}> = /*@__PURE__*/
  messageDesc(file_scale_service, 1);

/**
 * @generated from message raccoonai.ScaleResponse
 */
export type ScaleResponse = Message<"raccoonai.ScaleResponse"> & {
  /**
   * @generated from field: required raccoonai.ScaleRecord scale_record = 1 [json_name = "scale_record"];
   */
  scaleRecord?: ScaleRecord;
};

/**
 * @generated from message raccoonai.ScaleResponse
 */
export type ScaleResponseJson = {
  /**
   * @generated from field: required raccoonai.ScaleRecord scale_record = 1 [json_name = "scale_record"];
   */
  scale_record?: ScaleRecordJson;
};

/**
 * Describes the message raccoonai.ScaleResponse.
 * Use `create(ScaleResponseSchema)` to create a new message.
 */
export const ScaleResponseSchema: GenMessage<ScaleResponse, {jsonType: ScaleResponseJson}> = /*@__PURE__*/
  messageDesc(file_scale_service, 2);

/**
 * @generated from message raccoonai.ScaleRecordListRequest
 */
export type ScaleRecordListRequest = Message<"raccoonai.ScaleRecordListRequest"> & {
  /**
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional raccoonai.WasteType waste_type = 3 [json_name = "waste_type"];
   */
  wasteType: WasteType;

  /**
   * @generated from field: optional uint64 driver_id = 4 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 5 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_from = 6 [json_name = "brutto_scale_ts_from"];
   */
  bruttoScaleTsFrom?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_to = 7 [json_name = "brutto_scale_ts_to"];
   */
  bruttoScaleTsTo?: Timestamp;

  /**
   * facets: "waste_type" (WasteType). Pages newest weighing first.
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 8 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * Empty means every status.
   *
   * @generated from field: repeated raccoonai.ScaleRecordStatus statuses = 9;
   */
  statuses: ScaleRecordStatus[];

  /**
   * Organizations whose records to list, each checked; empty means the caller's own. ANDed with
   * the other filters: owner_organization_id and the rest only narrow it.
   *
   * @generated from field: repeated uint64 organization_ids = 10 [json_name = "organization_ids"];
   */
  organizationIds: bigint[];
};

/**
 * @generated from message raccoonai.ScaleRecordListRequest
 */
export type ScaleRecordListRequestJson = {
  /**
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional raccoonai.WasteType waste_type = 3 [json_name = "waste_type"];
   */
  waste_type?: WasteTypeJson;

  /**
   * @generated from field: optional uint64 driver_id = 4 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 5 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_from = 6 [json_name = "brutto_scale_ts_from"];
   */
  brutto_scale_ts_from?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_to = 7 [json_name = "brutto_scale_ts_to"];
   */
  brutto_scale_ts_to?: TimestampJson;

  /**
   * facets: "waste_type" (WasteType). Pages newest weighing first.
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 8 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * Empty means every status.
   *
   * @generated from field: repeated raccoonai.ScaleRecordStatus statuses = 9;
   */
  statuses?: ScaleRecordStatusJson[];

  /**
   * Organizations whose records to list, each checked; empty means the caller's own. ANDed with
   * the other filters: owner_organization_id and the rest only narrow it.
   *
   * @generated from field: repeated uint64 organization_ids = 10 [json_name = "organization_ids"];
   */
  organization_ids?: string[];
};

/**
 * Describes the message raccoonai.ScaleRecordListRequest.
 * Use `create(ScaleRecordListRequestSchema)` to create a new message.
 */
export const ScaleRecordListRequestSchema: GenMessage<ScaleRecordListRequest, {jsonType: ScaleRecordListRequestJson}> = /*@__PURE__*/
  messageDesc(file_scale_service, 3);

/**
 * @generated from message raccoonai.ScaleRecordListResponse
 */
export type ScaleRecordListResponse = Message<"raccoonai.ScaleRecordListResponse"> & {
  /**
   * @generated from field: repeated raccoonai.ScaleRecord scale_records = 1 [json_name = "scale_records"];
   */
  scaleRecords: ScaleRecord[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ScaleRecordListResponse
 */
export type ScaleRecordListResponseJson = {
  /**
   * @generated from field: repeated raccoonai.ScaleRecord scale_records = 1 [json_name = "scale_records"];
   */
  scale_records?: ScaleRecordJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ScaleRecordListResponse.
 * Use `create(ScaleRecordListResponseSchema)` to create a new message.
 */
export const ScaleRecordListResponseSchema: GenMessage<ScaleRecordListResponse, {jsonType: ScaleRecordListResponseJson}> = /*@__PURE__*/
  messageDesc(file_scale_service, 4);

/**
 * @generated from message raccoonai.RawScaleRecordListRequest
 */
export type RawScaleRecordListRequest = Message<"raccoonai.RawScaleRecordListRequest"> & {
  /**
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string sender = 2;
   */
  sender: string;

  /**
   * @generated from field: optional string receiver = 3;
   */
  receiver: string;

  /**
   * @generated from field: optional string waste_type = 4 [json_name = "waste_type"];
   */
  wasteType: string;

  /**
   * @generated from field: optional string truck_number = 5 [json_name = "truck_number"];
   */
  truckNumber: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_from = 6 [json_name = "brutto_scale_ts_from"];
   */
  bruttoScaleTsFrom?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_to = 7 [json_name = "brutto_scale_ts_to"];
   */
  bruttoScaleTsTo?: Timestamp;

  /**
   * Organizations whose records to list, each checked; empty means the caller's own. ANDed with
   * the other filters: owner_organization_id and the rest only narrow it.
   *
   * @generated from field: repeated uint64 organization_ids = 8 [json_name = "organization_ids"];
   */
  organizationIds: bigint[];
};

/**
 * @generated from message raccoonai.RawScaleRecordListRequest
 */
export type RawScaleRecordListRequestJson = {
  /**
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string sender = 2;
   */
  sender?: string;

  /**
   * @generated from field: optional string receiver = 3;
   */
  receiver?: string;

  /**
   * @generated from field: optional string waste_type = 4 [json_name = "waste_type"];
   */
  waste_type?: string;

  /**
   * @generated from field: optional string truck_number = 5 [json_name = "truck_number"];
   */
  truck_number?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_from = 6 [json_name = "brutto_scale_ts_from"];
   */
  brutto_scale_ts_from?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp brutto_scale_ts_to = 7 [json_name = "brutto_scale_ts_to"];
   */
  brutto_scale_ts_to?: TimestampJson;

  /**
   * Organizations whose records to list, each checked; empty means the caller's own. ANDed with
   * the other filters: owner_organization_id and the rest only narrow it.
   *
   * @generated from field: repeated uint64 organization_ids = 8 [json_name = "organization_ids"];
   */
  organization_ids?: string[];
};

/**
 * Describes the message raccoonai.RawScaleRecordListRequest.
 * Use `create(RawScaleRecordListRequestSchema)` to create a new message.
 */
export const RawScaleRecordListRequestSchema: GenMessage<RawScaleRecordListRequest, {jsonType: RawScaleRecordListRequestJson}> = /*@__PURE__*/
  messageDesc(file_scale_service, 5);

/**
 * @generated from message raccoonai.RawScaleRecordListResponse
 */
export type RawScaleRecordListResponse = Message<"raccoonai.RawScaleRecordListResponse"> & {
  /**
   * @generated from field: repeated raccoonai.RawScaleRecord raw_scale_records = 1 [json_name = "raw_scale_records"];
   */
  rawScaleRecords: RawScaleRecord[];
};

/**
 * @generated from message raccoonai.RawScaleRecordListResponse
 */
export type RawScaleRecordListResponseJson = {
  /**
   * @generated from field: repeated raccoonai.RawScaleRecord raw_scale_records = 1 [json_name = "raw_scale_records"];
   */
  raw_scale_records?: RawScaleRecordJson[];
};

/**
 * Describes the message raccoonai.RawScaleRecordListResponse.
 * Use `create(RawScaleRecordListResponseSchema)` to create a new message.
 */
export const RawScaleRecordListResponseSchema: GenMessage<RawScaleRecordListResponse, {jsonType: RawScaleRecordListResponseJson}> = /*@__PURE__*/
  messageDesc(file_scale_service, 6);

/**
 * @generated from service raccoonai.ScaleService
 */
export const ScaleService: GenService<{
  /**
   * @generated from rpc raccoonai.ScaleService.ScaleBrutto
   */
  scaleBrutto: {
    methodKind: "unary";
    input: typeof ScaleBruttoRequestSchema;
    output: typeof ScaleResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ScaleService.ScaleNetto
   */
  scaleNetto: {
    methodKind: "unary";
    input: typeof ScaleNettoRequestSchema;
    output: typeof ScaleResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ScaleService.ScaleRecordList
   */
  scaleRecordList: {
    methodKind: "unary";
    input: typeof ScaleRecordListRequestSchema;
    output: typeof ScaleRecordListResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ScaleService.ScaleRecordById
   */
  scaleRecordById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof ScaleResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ScaleService.RawScaleRecordList
   */
  rawScaleRecordList: {
    methodKind: "unary";
    input: typeof RawScaleRecordListRequestSchema;
    output: typeof RawScaleRecordListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_scale_service, 0);

